import { Svg } from 'ixfx/visual';
import { CreatedRing, Scaler, WindDataPoint } from './types';
import { Lines, Point, Polar, radianToDegree } from "ixfx/geometry";
import * as PolarRay from './polar-ray';
import { piPi } from 'ixfx/data';
import * as Anim from './anim';
import { Easings } from 'ixfx/modulation';

export type Settings = {
  barMaximum: number,
  strokeStyle: string,
  minimumThickness: number,
  gustThicknessScale: number,
  ringDurationMs: number,
  svg: Svg.SvgHelper,
  speedScale: Scaler,
  gustScale: Scaler,
  origin: Point
}

export function createRing(ringIndex: number, settings: Settings, ring: WindDataPoint[]): CreatedRing {
  const { svg, origin, barMaximum: pixelScale, gustThicknessScale, minimumThickness, strokeStyle, speedScale, gustScale } = settings;
  const offset = ringIndex * (pixelScale + 15);
  const svgElements: SVGLineElement[] = [];
  const animationsTogether = [];
  const animationsStaggered = [];
  for (const r of ring) {
    const speed = speedScale(r.speed);
    const gust = gustScale(r.gusts);

    // Swizzle angle a bit to match up with cardinal directions
    const direction = (r.direction - Math.PI / 2) % piPi;
    const lengthSpeed = speed * pixelScale;
    const ray: PolarRay.PolarRay = {
      angleRadian: direction,
      length: lengthSpeed,
      start: offset
    }
    const line = PolarRay.toCartesian(ray, origin);

    const l = svg.line(line, {
      strokeWidth: minimumThickness + (gustThicknessScale * gust),
      strokeStyle,
      strokeLineCap: `round`
    });
    (l as any).ray = ray
    svgElements.push(l);
    l.innerHTML = `<title>${ new Date(r.time).toLocaleString() } Speed: ${ r.speed } Gusts: ${ r.gusts } Direction: ${ Math.floor(radianToDegree(r.direction)) }</title>`;
    l.style.opacity = `0`;
    l.classList.add(`line`);
    animationsStaggered.push(Anim.styleAssign(`opacity`, 0, 1, Easings.Named.expoOut, l));
  }

  //const ringGroup = Anim.staggeredProgress(Anim.timerFactory(`elapsed`, 10000), 0.01, animationsTogether);
  //const ringTogether = Anim.together(Anim.timerFactory(`elapsed`, 10_000), animationsTogether);
  const ringStaggered = Anim.staggeredProgress(Anim.timerFactory(`elapsed`, 5_000), 0.05, animationsStaggered);
  const ringDelay = Anim.predelay(Anim.timerFactory(`elapsed`, 3000 * ringIndex), ringStaggered);
  return { elements: svgElements, group: ringDelay };
}


export function createRings(settings: Settings, rings: WindDataPoint[][]): CreatedRing[] {
  const { svg } = settings;
  svg.clear();
  rings.reverse(); // So 0th index is now
  const visualRings: CreatedRing[] = [];

  for (let i = 0; i < rings.length; i++) {
    const r = createRing(i, settings, rings[ i ]);
    visualRings.push(r);
  }
  return visualRings
}
